import React from 'react'

const Mt7 = () => {
    return (
        <div className='container'>
        <h1>Longest prefix which is also suffix</h1>
        <p>Given a string s, find the length of the longest prefix, which is also a suffix. The prefix and suffix should not overlap.</p>
        <p><strong>Examples:&nbsp;</strong></p>
        <pre className='containers'>Input : aabcdaabc <br />
Output : 4 <br />
The string "aabc" is the longest <br />
prefix which is also suffix. <br />
<br />
Input : abcab <br />
Output : 2 <br />
<br />
Input : aaaa <br />
Output : 2</pre>
<p><strong>Efficient Solution: </strong>The idea is to use the preprocessing algorithm KMP search. In the preprocessing algorithm, we build lps array which stores the following values.</p>
<blockquote className='containers'><p>lps[i] = the longest proper prefix of pat[0..i]&nbsp;<br/>
which is also a suffix of pat[0..i].</p></blockquote>

    <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>


<div class="tab-content-wrapper">
<div id="tab-content-1" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Efficient CPP program to find length of</code></div>
<div class="line number2 index1 alt1"><code class="comments">// the longest prefix which is also suffix</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
<div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="comments">// Returns length of the longest prefix</code></div>
<div class="line number7 index6 alt2"><code class="comments">// which is also suffix and the two do</code></div>
<div class="line number8 index7 alt1"><code class="comments">// not overlap. This function mainly is</code></div>
<div class="line number9 index8 alt2"><code class="comments">// copy computeLPSArray() of in below post</code></div>

<div class="line number11 index10 alt2"><code class="color1 bold">int</code> <code
        class="plain">longestPrefixSuffix(string s)</code></div>
<div class="line number12 index11 alt1"><code class="plain">&#123;</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">n = s.length();</code></div>
<div class="line number14 index13 alt1">&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">lps[n];</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[0] = 0; </code><code class="comments">// lps[0] is always 0</code></div>
<div class="line number17 index16 alt2">&nbsp;</div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// length of the previous</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// longest prefix suffix</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">len = 0;</code></div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// the loop calculates lps[i]</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// for i = 1 to n-1</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">i = 1;</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(i &lt; n)</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(s[i] == s[len])</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">len++;</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[i] = len;</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">i++;</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code> <code class="comments">// (pat[i] != pat[len])</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// This is tricky. Consider</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// the example. AAACAAAA</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// and i = 7. The idea is</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// similar to search step.</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(len != 0)</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">len = lps[len-1];</code></div>
<div class="line number42 index41 alt1">&nbsp;</div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Also, note that we do</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// not increment i here</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">else</code> <code class="comments">// if (len == 0)</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number48 index47 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[i] = 0;</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">i++;</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number53 index52 alt2">&nbsp;</div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">res = lps[n-1];</code></div>
<div class="line number55 index54 alt2">&nbsp;</div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Since we are looking for</code></div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// non overlapping parts.</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(res &gt; n/2)? res/2 : res;</code></div>
<div class="line number59 index58 alt2"><code class="plain">&#125;</code></div>
<div class="line number60 index59 alt1">&nbsp;</div>
<div class="line number61 index60 alt2"><code class="comments">// Driver program to test above function</code></div>
<div class="line number62 index61 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number63 index62 alt2"><code class="plain">&#123;</code></div>
<div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">string s = </code><code class="string">"abcab"</code><code class="plain">;</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; longestPrefixSuffix(s);</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number67 index66 alt2"><code class="plain">&#125;</code></div>
</div>
</div>
<div id="tab-content-2" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Efficient Java program to find length of</code>
</div>
<div class="line number2 index1 alt1"><code class="comments">// the longest prefix which is also suffix</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="keyword">class</code> <code class="plain">NooB</code></div>
<div class="line number5 index4 alt2"><code class="plain">&#123;</code></div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Returns length of the longest prefix</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// which is also suffix and the two do</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// not overlap. This function mainly is</code></div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// copy computeLPSArray() of in below post</code></div>
\
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// for-patterns-set-2-kmp-algorithm/</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">int</code> <code
        class="plain">longestPrefixSuffix(String s)</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">n = s.length();</code></div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">lps[] = </code><code class="keyword">new</code> <code
        class="keyword">int</code><code class="plain">[n];</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// lps[0] is always 0</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[</code><code class="value">0</code><code class="plain">] = </code><code
        class="value">0</code><code class="plain">;</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number21 index20 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// length of the previous</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// longest prefix suffix</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">len = </code><code class="value">0</code><code
        class="plain">;</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// the loop calculates lps[i]</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// for i = 1 to n-1</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">i = </code><code class="value">1</code><code
        class="plain">;</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code> <code class="plain">(i &lt; n)</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(s.charAt(i) == s.charAt(len))</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">len++;</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[i] = len;</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">i++;</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// (pat[i] != pat[len])</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// This is tricky. Consider</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// the example. AAACAAAA</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// and i = 7. The idea is</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// similar to search step.</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(len != </code><code class="value">0</code><code
        class="plain">)</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">len = lps[len-</code><code class="value">1</code><code class="plain">];</code></div>
<div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number48 index47 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Also, note that we do</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// not increment i here</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// if (len == 0)</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[i] = </code><code class="value">0</code><code class="plain">;</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">i++;</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">res = lps[n-</code><code class="value">1</code><code
        class="plain">];</code></div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number63 index62 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Since we are looking for</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// non overlapping parts.</code></div>
<div class="line number65 index64 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">(res &gt; n/</code><code class="value">2</code><code
        class="plain">)? n/</code><code class="value">2</code> <code class="plain">: res;</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Driver program</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main (String[] args)</code></div>
<div class="line number70 index69 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">String s = </code><code class="string">"abcab"</code><code class="plain">;</code></div>
<div class="line number72 index71 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(longestPrefixSuffix(s));</code></div>
<div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number74 index73 alt1"><code class="plain">&#125;</code></div>
<div class="line number75 index74 alt2">&nbsp;</div>
<div class="line number76 index75 alt1"><code class="comments">// This code is contributed by Anant Agarwal.</code>
</div>
</div>
</div> 
<div id="tab-content-3" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Efficient Python 3 program</code></div>
<div class="line number2 index1 alt1"><code class="comments"># to find length of</code></div>
<div class="line number3 index2 alt2"><code class="comments"># the longest prefix</code></div>
<div class="line number4 index3 alt1"><code class="comments"># which is also suffix</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="comments"># Returns length of the longest prefix</code></div>
<div class="line number7 index6 alt2"><code class="comments"># which is also suffix and the two do</code></div>
<div class="line number8 index7 alt1"><code class="comments"># not overlap. This function mainly is</code></div>
<div class="line number9 index8 alt2"><code class="comments"># copy computeLPSArray() of in below post</code></div>

<div class="line number11 index10 alt2"><code class="keyword">def</code> <code
        class="plain">longestPrefixSuffix(s) :</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">n </code><code class="keyword">=</code> <code class="functions">len</code><code
        class="plain">(s)</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps </code><code class="keyword">=</code> <code class="plain">[</code><code
        class="value">0</code><code class="plain">] </code><code class="keyword">*</code> <code
        class="plain">n&nbsp;&nbsp; </code><code class="comments"># lps[0] is always 0</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># length of the previous</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># longest prefix suffix</code></div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">l </code><code class="keyword">=</code> <code class="value">0</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># the loop calculates lps[i]</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># for i = 1 to n-1</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">i </code><code class="keyword">=</code> <code class="value">1</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code> <code class="plain">(i &lt; n) :</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(s[i] </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="plain">s[l]) :</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">l </code><code class="keyword">=</code> <code class="plain">l </code><code
        class="keyword">+</code> <code class="value">1</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[i] </code><code class="keyword">=</code> <code class="plain">l</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">i </code><code class="keyword">=</code> <code class="plain">i </code><code
        class="keyword">+</code> <code class="value">1</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code> <code class="plain">:</code></div>
<div class="line number29 index28 alt2">&nbsp;</div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># (pat[i] != pat[len])</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># This is tricky. Consider</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># the example. AAACAAAA</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># and i = 7. The idea is</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># similar to search step.</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(l !</code><code class="keyword">=</code> <code
        class="value">0</code><code class="plain">) :</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">l </code><code class="keyword">=</code> <code class="plain">lps[l</code><code
        class="keyword">-</code><code class="value">1</code><code class="plain">]</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Also, note that we do</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># not increment i here</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
</div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code> <code class="plain">:</code></div>
<div class="line number42 index41 alt1">&nbsp;</div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># if (len == 0)</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lps[i] </code><code class="keyword">=</code> <code class="value">0</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">i </code><code class="keyword">=</code> <code class="plain">i </code><code
        class="keyword">+</code> <code class="value">1</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">res </code><code class="keyword">=</code> <code class="plain">lps[n</code><code
        class="keyword">-</code><code class="value">1</code><code class="plain">]</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Since we are looking for</code></div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># non overlapping parts.</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code><code class="plain">(res &gt; n</code><code class="keyword">/</code><code
        class="value">2</code><code class="plain">) :</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">n</code><code class="keyword">/</code><code
        class="keyword">/</code><code class="value">2</code></div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code> <code class="plain">:</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">res</code></div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number57 index56 alt2"><code class="comments"># Driver program to test above function</code></div>
<div class="line number58 index57 alt1"><code class="plain">s </code><code class="keyword">=</code> <code
        class="string">"abcab"</code></div>
<div class="line number59 index58 alt2"><code class="functions">print</code><code
        class="plain">(longestPrefixSuffix(s))</code></div>
<div class="line number60 index59 alt1">&nbsp;</div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code class="comments"># This code is contributed</code></div>
<div class="line number63 index62 alt2"><code class="comments"># by Nikita Tiwari.</code></div>
</div>
</div>

</div>
</div>
<br /> <br /> <br /> <br /> <br />

</div>
    )
}

export default Mt7
